module.exports = __webpack_public_path__ + "img/aceB2.c2d52735.jpg";